const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sngsteel.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${siteUrl}/#business`,
  name: '시너지스틸',
  alternateName: ['Synergy Steel', 'SNG Steel', 'Synergy Steel Co.'],
  description:
    'Synergy Steel (시너지스틸) is a specialized supplier of seamless pipes, tubes, pressure pipes, fittings, flanges, steel piles, and PE coating pipes in Korea. Competitive pricing and fast delivery. Tel: 02-6941-1750',
  url: siteUrl,
  telephone: '02-6941-1750',
  faxNumber: '02-6919-1781',
  email: 'workmin@sngsteel.com',
  foundingDate: '2010',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '한강대로 69 업무동 702호',
    addressLocality: 'Yongsan-gu',
    addressRegion: 'Seoul',
    postalCode: '04378',
    addressCountry: 'KR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.5291,
    longitude: 126.9642,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00',
    },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Steel Pipe & Tube Product Lineup',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Product',
          name: 'Seamless Pipe (심레스 파이프)',
          description: 'Seamless steel pipe supplier in Korea — 심레스 파이프 전문 공급',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Product',
          name: 'Steel Tube (튜브)',
          description: 'Seamless steel tube supplier — 심레스 튜브 전문 공급',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Product',
          name: 'Pipe Fitting (피팅)',
          description: 'Steel pipe fitting supplier — 강관 피팅 전문 공급',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Product',
          name: 'Flange (플랜지)',
          description: 'Steel flange supplier — 강관 플랜지 전문 공급',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Product',
          name: 'Steel Pile (강관말뚝)',
          description: 'Steel pile supplier in Korea — 강관말뚝(파일) 전문 공급',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Product',
          name: 'PE Coating Pipe (PE 코팅 파이프)',
          description: 'PE coating steel pipe supplier — PE코팅 강관 전문 공급',
        },
      },
    ],
  },
  areaServed: {
    '@type': 'Country',
    name: 'South Korea',
  },
  sameAs: [],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${siteUrl}/#website`,
  url: siteUrl,
  name: 'Synergy Steel | Seamless Pipe, Tube, Fitting, Flange, Steel Pile Supplier Korea',
  alternateName: '시너지스틸 | 심레스 파이프, 튜브, 압력배관, 강관말뚝, 피팅 전문 공급 업체',
  description:
    'Synergy Steel (시너지스틸) — Korea\'s trusted supplier of seamless pipes, tubes, pressure pipes, fittings, flanges and steel piles with competitive pricing and fast nationwide delivery.',
  publisher: {
    '@id': `${siteUrl}/#business`,
  },
  inLanguage: ['ko-KR', 'en'],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${siteUrl}/#webpage`,
  url: siteUrl,
  name: 'Synergy Steel | Seamless Pipe, Tube, Fitting, Flange, Pile Supplier in Korea',
  description:
    'Synergy Steel (시너지스틸) supplies seamless pipes, tubes, pressure pipes, fittings, flanges, steel piles and PE coating pipes. Competitive pricing and fast delivery. Tel: 02-6941-1750',
  isPartOf: { '@id': `${siteUrl}/#website` },
  about: { '@id': `${siteUrl}/#business` },
  inLanguage: ['ko-KR', 'en'],
  dateModified: '2026-04-22',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Where is Synergy Steel (시너지스틸) located?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Synergy Steel is located at 69 Hangang-daero, Rm 702, Yongsan-gu, Seoul, Korea (Postal code: 04378). 서울특별시 용산구 한강대로 69 업무동 702호',
      },
    },
    {
      '@type': 'Question',
      name: 'What products does Synergy Steel supply? (시너지스틸 주요 제품)',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Synergy Steel specializes in seamless pipes, steel tubes, pressure pipes, pipe fittings, flanges, steel piles, and PE coating pipes. All products meet KS and international standards. 심레스 파이프, 튜브, 피팅, 플랜지, 강관말뚝, PE코팅 강관을 전문으로 공급합니다.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I request a quote from Synergy Steel?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can contact Synergy Steel by phone (02-6941-1750 / 010-7375-1750), email (workmin@sngsteel.com), or via the inquiry form on the website. A representative will respond within 24 hours.',
      },
    },
    {
      '@type': 'Question',
      name: 'Does Synergy Steel deliver nationwide in Korea?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Synergy Steel operates a stable supply chain from its headquarters in Yongsan-gu, Seoul, and delivers to construction and industrial sites across all of Korea.',
      },
    },
    {
      '@type': 'Question',
      name: 'What certifications does Synergy Steel hold?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Synergy Steel holds KS (Korean Industrial Standards) certification, ISO 9001 (Quality Management System), and is registered with the Korea Public Procurement Service (조달청), making it eligible for public institution and large-scale project supply.',
      },
    },
  ],
};

export default function SeoJsonLd() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}
